define('models/Location',[
    'lib/knockout',
    'util/ObservableModel'
], function (ko, ObservableModel) {
    'use strict';

    var Location = ObservableModel.extend({
        defaults: {
            id: 0,
            name: ''
        }
    }, function () {});

    return Location;
});

